"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Paragraph = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@phishtool/ui");
const Paragraph = (props) => (0, jsx_runtime_1.jsx)(ui_1.Paragraph, Object.assign({}, props, { letterSpacing: true }));
exports.Paragraph = Paragraph;
